<template>
  <div></div>
</template>

<script>
  export default {
    created() {
      const component = this;
      this.handler = function (e) {
        component.$emit('keyup', e);
      }
      this.handler2 = function (e) {
        component.$emit('keydown', e);
      }
      this.handler3 = function (e) {
        component.$emit('keypress', e);
      }
      document.addEventListener('keyup', this.handler);
      document.addEventListener('keydown', this.handler2);
      document.addEventListener('keypress', this.handler3);
    },
    beforeDestroy() {
      document.removeEventListener('keyup', this.handler);
      document.removeEventListener('keydown', this.handler2);
      document.removeEventListener('keypress', this.handler3);
    }
  }
</script>

<style scoped>
  div {
    display: none;
  }
</style>